import { useAxios } from "utils/axiosHook";

const useGetBeacon = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "GET",
    },
    { manual: true }
  );

  const service = (studentId) => {
    return api({ url: `management/students/${studentId}/beacons` });
  };

  return { data, loading, error, service };
};

const useAddBeacon = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "POST",
    },
    { manual: true }
  );

  const service = (studentId, data) => {
    return api({ url: `/management/students/${studentId}/beacons`, data: data });
  };

  return { data, loading, error, service };
};

const useUpdateBeacon = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "PUT",
    },
    { manual: true }
  );

  const service = (studentId, beaconId, data) => {
    return api({
      url: `management/students/${studentId}/beacons/${beaconId}`,
      data: data,
    });
  };

  return { data, loading, error, service };
};

export { useGetBeacon, useAddBeacon, useUpdateBeacon };
